/**
 * 场景路由（`mode_model_config`）的接口。两个 routeId，与
 * `apps/visual-game-server/src/routes/llm-admin/modes.js` 的 `@callchain.routeId` 标注逐字对应。
 *
 * 返回形状（后端实测）：
 *   listModes     → `{ items: ModeRow[] }`
 *   saveModeChain → `ModeRow`（保存后的那一行，直接拿它刷新界面，不再回查一次）
 *
 * `required: true` = 这个 mode 在 `RUNTIME_MODES` 里（今天只有 `kp`），runtime 每个游戏请求都会
 * `forMode` 它。链空了或停用了，每个请求都炸 —— 后端配置断言会以 409 拒绝并回滚。
 *
 * 保存这条链就是这个后台的核心动作：写事务提交后后端 bump 配置版本 + `llm.invalidate()`，
 * **下一次调用**（不重启、不等 TTL）就走新链。
 *
 * @typedef {{ provider: string, model: string }} ChainStep
 * @typedef {{ id: string, mode: string, chain: ChainStep[], enabled: boolean,
 *   updated_at: string, required: boolean }} ModeRow
 */

import { llmHttp } from './http.js'

/**
 * @callchain.routeId llm.admin.modes.list
 * @returns {Promise<{ items: ModeRow[] }>}
 */
export function listLlmModes() {
  return llmHttp().get('/modes', { routeId: 'llm.admin.modes.list' })
}

/**
 * 整条链落库（覆盖式）。`chain` 有序，索引 0 是主力。
 * @callchain.routeId llm.admin.modes.save
 * @param {string} mode
 * @param {{ chain: ChainStep[], enabled?: boolean }} input
 * @returns {Promise<ModeRow>}
 */
export function saveLlmModeChain(mode, input) {
  return llmHttp().post(`/modes/${encodeURIComponent(mode)}`, {
    body: input,
    routeId: 'llm.admin.modes.save',
  })
}
